import { render, staticRenderFns } from "./selected.vue?vue&type=template&id=0004aa41&scoped=true"
import script from "./selected.vue?vue&type=script&lang=js"
export * from "./selected.vue?vue&type=script&lang=js"
import style0 from "./selected.vue?vue&type=style&index=0&id=0004aa41&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0004aa41",
  null
  
)

export default component.exports